import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ShowElapsedTimer extends BaseOption {
  static userInterfaceComponent = {
    label: "Show Elapsed Timer",
    optionDataType: BaseOption.DataType.Boolean,
    component: inspectorTools.RADIO_BAR,
    descriptionMessage: "The running timer shown in the top-left corner during a call or stream.",
    props: {
      options: [
        {
          label: "Yes",
          value: true,
          tooltip: "",
        },
        {
          label: "No",
          value: false,
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = true;

  static convertConfigValueToCompiledValue(configValue) {
    return [true, "true", "yes"].includes(configValue);
  }
}
